import { MiniEventCard, renderMarketsAmerican } from "../../../components";

export class American extends MiniEventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.cardTypeClass = `rj-ev-list__${this.componentPrefix}--american`;
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder--american`;
    }

    renderMarkets = renderMarketsAmerican;
}